export const getComponents = (
  fonts: string[] = [],
  muiButtonStyleOverride = {}
) => ({
  MuiButton: {
    defaultProps: {
      disableElevation: true
    },
    styleOverrides: {
      root: muiButtonStyleOverride
    }
  },
  MuiCssBaseline: {
    styleOverrides: fonts.join('\n')
  },
  MuiOutlinedInput: {
    styleOverrides: {
      input: {
        padding: '14px 12px'
      }
    }
  }
});
